/* eslint-disable array-callback-return */
import React, { useEffect } from 'react';
import Box from '@material-ui/core/Box';
import { startTimeDisplay, parseDateUtc } from '../../../utils/dates';
import globals from '../../../globals/communityGlobals';
import { treatmentTimeTypes } from '../../../enums/treatmentTimeTypes';

const locale = globals.getArea('treatments');
export default function BundleVisitSlots({
  items,
  isTimeSlots,
  isSpecific,
  isMultiple,
  treatmentInstancesSlots,
  setSelectedSlotFrom,
  setTreatmentInstancesSlots,
  setTimeSlots,
}) {
  const sortTimeSlots = (a, b) => {
    return parseDateUtc(a.from) - parseDateUtc(b.from);
  };

  const distinctByTimeSlot = slots => {
    const distinctTimeSlots = [];

    slots.map(timeSlot => {
      const findTimeSlot = distinctTimeSlots.find(x => x.from === timeSlot.from);
      if (!findTimeSlot) distinctTimeSlots.push(timeSlot);
    });

    return distinctTimeSlots;
  };

  const getTimeSlots = () => {
    const allTimeSlots = items.flatMap(x => x.timeSlots);
    let distinctTimeSlots = distinctByTimeSlot(allTimeSlots);

    if ((isSpecific.length >= 1 || isMultiple.length >= 1) && isTimeSlots.length > 0) {
      distinctTimeSlots = items
        .filter(x => x.treatmentTimeType !== treatmentTimeTypes.timeslot)
        .map(x => x.timeSlots)
        .flat();
      distinctTimeSlots = distinctByTimeSlot(distinctTimeSlots);
    }
    return distinctTimeSlots.sort((a, b) => sortTimeSlots(a, b));
  };

  const timeSlots = getTimeSlots();

  useEffect(() => {
    setTimeSlots(timeSlots);
  }, []);

  const handleTimeSlotSelectionChange = from => {
    const selectedTimeSlot = { ...treatmentInstancesSlots };
    if (selectedTimeSlot[from]) {
      delete selectedTimeSlot[from];
      setSelectedSlotFrom(null);
    } else {
      const selectedSlot = Object.assign({}, timeSlots.find(timeSlot => timeSlot.from === from));
      const unselectedSlots = timeSlots.filter(timeSlot => timeSlot.from !== from);

      if (selectedSlot) {
        setSelectedSlotFrom(selectedSlot.from);
        if (unselectedSlots) {
          unselectedSlots.forEach(x => {
            delete selectedTimeSlot[x.from];
          });
        }
      }
      selectedTimeSlot[from] = true;
    }
    setTreatmentInstancesSlots(selectedTimeSlot);
  };

  const getWarningMsg = () => {
    if (timeSlots.length > 1 && isSpecific.length >= 1 && isMultiple.length >= 1) {
      return locale.getMsg('visitsWithDifferentTime');
    }

    if (timeSlots.length > 1 && isMultiple.length > 1) {
      return locale.getMsg('visitsWithDifferentTime');
    }

    if (timeSlots.length > 1 && isSpecific.length > 1) {
      return locale.getMsg('specificTimeVisitsWarningMsg');
    }

    return '';
  };

  const showTimeSlots = () => {
    return getWarningMsg() !== '';
  };

  const warningPlaceholder = () => {
    const warningMsg = getWarningMsg();
    if (warningMsg === '') return null;

    return (
      <span className="form-validation-error">
        <p>{warningMsg}</p>
      </span>
    );
  };

  return (
    <Box sx={{ mt: 2 }}>
      {warningPlaceholder()}
      {showTimeSlots() && (
        <Box sx={{ mt: 2 }}>
          <div className="clinician-info-box">
            <div className="rostered-table reccurence-patient">
              <Box flexWrap="wrap" display="flex" flexDirection="row" className="timeslotes-container">
                {timeSlots.map(slot => (
                  <Box className="rostered-table-item" key={`${0}_${slot.from}`}>
                    <span className="day">{startTimeDisplay(slot.from, slot.to)}</span>
                    <div
                      className="rostered-time"
                      role="button"
                      tabIndex={0}
                      onClick={() => handleTimeSlotSelectionChange(slot.from)}
                    >
                      <Box
                        style={{
                          backgroundColor: treatmentInstancesSlots[slot.from] === true ? '#96E5B7' : '#E8E7E6',
                          padding: '8px',
                        }}
                      />
                    </div>
                  </Box>
                ))}
              </Box>
            </div>
          </div>
        </Box>
      )}
    </Box>
  );
}
